var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ContentWrapper",
    [
      _c("div", { staticClass: "content-heading" }, [
        _c("div", [_vm._v("참고서관리")]),
        _c("ol", { staticClass: "breadcrumb ml-auto" }, [
          _c("li", { staticClass: "breadcrumb-item" }, [
            _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
          ]),
          _c("li", { staticClass: "breadcrumb-item" }, [
            _vm._v("\n        컨텐츠관리\n      ")
          ]),
          _c("li", { staticClass: "breadcrumb-item active" }, [
            _c("a", { attrs: { href: "/cs/referencebook/" } }, [
              _vm._v("참고서관리")
            ])
          ])
        ])
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.params.mode == "list",
              expression: "data.params.mode=='list'"
            }
          ],
          staticClass: "card card-default"
        },
        [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "div",
              { staticClass: "form-row align-items-center" },
              [
                _c("SchSchoolType", {
                  attrs: { label: "학교급", data: _vm.data, txt: "reference" },
                  on: { search: _vm.search, reset: _vm.reset }
                }),
                _c("sch-text", {
                  attrs: { label: "검색어", data: _vm.data },
                  on: { search: _vm.search, reset: _vm.reset }
                })
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.params.mode == "list",
              expression: "data.params.mode=='list'"
            }
          ],
          staticClass: "card card-default"
        },
        [
          _c("div", { staticClass: "page-search mt-3 ml-3" }, [
            _c("span", { staticClass: "d-inline-block" }, [
              _vm._v("결과 내 검색")
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchText,
                  expression: "searchText"
                }
              ],
              staticClass: "d-inline-block form-control ml-2",
              staticStyle: { width: "200px" },
              attrs: { type: "text", name: "updId" },
              domProps: { value: _vm.searchText },
              on: {
                change: function($event) {
                  return _vm.SearchInPage(_vm.searchText, _vm.data.list)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchText = $event.target.value
                }
              }
            }),
            _c(
              "div",
              { staticClass: "card-tool float-right" },
              [
                _c(
                  "b-btn",
                  {
                    staticClass: "btn btn-xs btn-outline-info mr-2",
                    attrs: { variant: "outline-primary" },
                    on: {
                      click: function($event) {
                        return _vm.openAddPopup()
                      }
                    }
                  },
                  [_vm._v("+ 신규 참고서 등록")]
                ),
                _c(
                  "b-btn",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.bookModal",
                        modifiers: { bookModal: true }
                      }
                    ],
                    staticClass: "btn btn-xs btn-outline-info mr-2",
                    attrs: { variant: "outline-primary" }
                  },
                  [_vm._v("북샘 참고서 불러오기")]
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "card-header mt-2" }, [
            _vm._v("\n      목록\n    ")
          ]),
          _c("div", { staticClass: "card-body" }, [
            _c(
              "table",
              { staticClass: "table table-striped table-bordered table-hover" },
              [
                _c("thead", [
                  _c("tr", [
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v("이미지")
                    ]),
                    _c(
                      "td",
                      {
                        staticStyle: { "text-align": "center" },
                        on: {
                          click: function($event) {
                            return _vm.localSort.sort("textbookNm")
                          }
                        }
                      },
                      [
                        _vm._v("교재명"),
                        _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                      ]
                    ),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v("카테고리")
                    ]),
                    _c(
                      "td",
                      {
                        staticStyle: { "text-align": "center" },
                        on: {
                          click: function($event) {
                            return _vm.localSort.sort("author")
                          }
                        }
                      },
                      [
                        _vm._v("저자"),
                        _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: { "text-align": "center" },
                        on: {
                          click: function($event) {
                            return _vm.localSort.sort("regId")
                          }
                        }
                      },
                      [
                        _vm._v("등록자"),
                        _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: { "text-align": "center" },
                        on: {
                          click: function($event) {
                            return _vm.localSort.sort("updDt")
                          }
                        }
                      },
                      [
                        _vm._v("수정일"),
                        _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                      ]
                    ),
                    _c("td", { attrs: { width: "90" } }, [_vm._v("자세히보기")])
                  ])
                ]),
                _c(
                  "tbody",
                  [
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.data.count == 0,
                            expression: "data.count==0"
                          }
                        ],
                        staticClass: "text-center"
                      },
                      [
                        _c("td", { attrs: { colspan: "9" } }, [
                          _vm._v("No matching records")
                        ])
                      ]
                    ),
                    _vm._l(_vm.data.list, function(item, index) {
                      return _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.searchText.length == 0,
                              expression: "searchText.length == 0"
                            }
                          ],
                          key: index + "r",
                          on: {
                            click: function($event) {
                              return _vm.edit(item.bookSeq)
                            }
                          }
                        },
                        [
                          _c(
                            "td",
                            { staticClass: "align-middle text-center" },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.data.aws_cdn_path + item.fileUrl,
                                  width: "80"
                                }
                              })
                            ]
                          ),
                          _c("td", { staticClass: "align-middle" }, [
                            _vm._v(_vm._s(item.textbookNm))
                          ]),
                          _c(
                            "td",
                            { staticClass: "align-middle text-center" },
                            [
                              _c("b-form-select", {
                                staticClass:
                                  "not-select custom-select custom-select-sm",
                                attrs: { options: _vm.cateCd },
                                model: {
                                  value: item.cateCd,
                                  callback: function($$v) {
                                    _vm.$set(item, "cateCd", $$v)
                                  },
                                  expression: "item.cateCd"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        item.cateCd != null &&
                                        item.subjectCd != null,
                                      expression:
                                        "item.cateCd != null && item.subjectCd != null"
                                    }
                                  ]
                                },
                                [_vm._v(" > ")]
                              ),
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.cateCd != null,
                                    expression: "item.cateCd != null "
                                  }
                                ],
                                staticClass:
                                  "not-select custom-select custom-select-sm",
                                attrs: { options: _vm.RsubjectCd },
                                model: {
                                  value: item.subjectCd,
                                  callback: function($$v) {
                                    _vm.$set(item, "subjectCd", $$v)
                                  },
                                  expression: "item.subjectCd"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "td",
                            { staticClass: "align-middle text-center" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.author) +
                                  "\n          "
                              )
                            ]
                          ),
                          _c(
                            "td",
                            { staticClass: "align-middle text-center" },
                            [_vm._v(_vm._s(item.regId))]
                          ),
                          _c(
                            "td",
                            { staticClass: "align-middle text-center" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.updDt) +
                                  "\n          "
                              )
                            ]
                          ),
                          _c(
                            "td",
                            { staticClass: "align-middle text-center" },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      staticClass: "btn btn-sm btn-secondary",
                                      attrs: { variant: "outline-info mr-2" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.edit(item.bookSeq)
                                        }
                                      }
                                    },
                                    [_c("em", { staticClass: "fa fa-search" })]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.searchText.length > 0 &&
                              _vm.searchValue.length == 0,
                            expression:
                              "searchText.length > 0 && searchValue.length == 0"
                          }
                        ],
                        staticClass: "text-center"
                      },
                      [
                        _c("td", { attrs: { colspan: "9" } }, [
                          _vm._v("No matching records")
                        ])
                      ]
                    ),
                    _vm._l(_vm.searchValue, function(item, index) {
                      return _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.searchText.length > 0 &&
                                _vm.searchValue.length > 0,
                              expression:
                                "searchText.length > 0 && searchValue.length > 0"
                            }
                          ],
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.edit(item.bookSeq)
                            }
                          }
                        },
                        [
                          _c(
                            "td",
                            { staticClass: "align-middle text-center" },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.data.aws_cdn_path + item.fileUrl,
                                  width: "80"
                                }
                              })
                            ]
                          ),
                          _c("td", { staticClass: "align-middle" }, [
                            _vm._v(_vm._s(item.textbookNm))
                          ]),
                          _c(
                            "td",
                            { staticClass: "align-middle text-center" },
                            [
                              _c("b-form-select", {
                                staticClass:
                                  "not-select custom-select custom-select-sm",
                                attrs: { options: _vm.cateCd },
                                model: {
                                  value: item.cateCd,
                                  callback: function($$v) {
                                    _vm.$set(item, "cateCd", $$v)
                                  },
                                  expression: "item.cateCd"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        item.cateCd != null &&
                                        item.subjectCd != null,
                                      expression:
                                        "item.cateCd != null && item.subjectCd != null"
                                    }
                                  ]
                                },
                                [_vm._v(" > ")]
                              ),
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.cateCd != null,
                                    expression: "item.cateCd != null "
                                  }
                                ],
                                staticClass:
                                  "not-select custom-select custom-select-sm",
                                attrs: { options: _vm.RsubjectCd },
                                model: {
                                  value: item.subjectCd,
                                  callback: function($$v) {
                                    _vm.$set(item, "subjectCd", $$v)
                                  },
                                  expression: "item.subjectCd"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "td",
                            { staticClass: "align-middle text-center" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.author) +
                                  "\n          "
                              )
                            ]
                          ),
                          _c(
                            "td",
                            { staticClass: "align-middle text-center" },
                            [_vm._v(_vm._s(item.regId))]
                          ),
                          _c(
                            "td",
                            { staticClass: "align-middle text-center" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.updDt) +
                                  "\n          "
                              )
                            ]
                          ),
                          _c(
                            "td",
                            { staticClass: "align-middle text-center" },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      staticClass: "btn btn-sm btn-secondary",
                                      attrs: { variant: "outline-info mr-2" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.edit(item.bookSeq)
                                        }
                                      }
                                    },
                                    [_c("em", { staticClass: "fa fa-search" })]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]
            )
          ]),
          _c("div", { staticClass: "card-footer" }, [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("Pagenation", {
                  key: _vm.data.params.page,
                  attrs: { data: _vm.data },
                  on: {
                    next: function($event) {
                      return _vm.dataAction.next(_vm.search)
                    },
                    prev: function($event) {
                      return _vm.dataAction.prev(_vm.search)
                    },
                    first: function($event) {
                      return _vm.dataAction.first(_vm.search)
                    },
                    last: function($event) {
                      return _vm.dataAction.last(_vm.search)
                    }
                  }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm.data.params.mode == "detail"
        ? _c("CsTextBookAddPage", {
            attrs: { bookSeq: _vm.data.detailBookSeq, bookTypeCd: 330002 },
            on: { searchDepth: _vm.searchDepth, search: _vm.search }
          })
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.params.mode == "detail",
              expression: "data.params.mode=='detail'"
            }
          ],
          staticClass: "card card-default book-file"
        },
        [
          _c(
            "div",
            { staticClass: "card-body", staticStyle: { height: "611.8px" } },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-4" }, [
                  _c("p", [
                    _vm._v("단원\n            "),
                    _c(
                      "span",
                      { staticClass: "float-right" },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.uploadModalDepth1",
                                modifiers: { uploadModalDepth1: true }
                              }
                            ],
                            staticClass: "btn btn-xs btn-outline-info mr-2",
                            attrs: { variant: "outline-info mr-2" },
                            on: {
                              click: function($event) {
                                _vm.popupShowDepth1 = true
                              }
                            }
                          },
                          [_vm._v("+ 단원등록")]
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isShowDepth1,
                                expression: "!isShowDepth1"
                              }
                            ],
                            staticClass: "btn btn-xs btn-outline-info mr-2",
                            attrs: { variant: "outline-info mr-2" },
                            on: {
                              click: function($event) {
                                _vm.clickChangeData("depth1")
                                _vm.isShowDepth1 = true
                              }
                            }
                          },
                          [_vm._v("편집")]
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowDepth1,
                                expression: "isShowDepth1"
                              }
                            ],
                            staticClass: "btn btn-xs btn-outline-info mr-2",
                            attrs: { variant: "outline-info mr-2" },
                            on: {
                              click: function($event) {
                                _vm.isShowDepth1 = false
                                _vm.resetOrderNum("depth1")
                                _vm.editContSeq = 0
                              }
                            }
                          },
                          [_vm._v("취소")]
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowDepth1,
                                expression: "isShowDepth1"
                              }
                            ],
                            staticClass: "btn btn-xs btn-outline-info mr-2",
                            attrs: { variant: "outline-info mr-2" },
                            on: {
                              click: function($event) {
                                _vm.isShowDepth1 = false
                                _vm.saveChangeOrder("depth1")
                              }
                            }
                          },
                          [_vm._v("저장")]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "table",
                    { staticClass: "table table-striped table-hover" },
                    [
                      _c(
                        "tbody",
                        { staticClass: "div_scroll" },
                        [
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.atrbInfo.depth1.length == 0,
                                  expression: "atrbInfo.depth1.length==0"
                                }
                              ],
                              staticClass: "text-center"
                            },
                            [_c("td", [_vm._v("No matching records")])]
                          ),
                          _c(
                            "draggable",
                            {
                              attrs: {
                                options: {
                                  group: "depth1",
                                  disabled: !_vm.isShowDepth1
                                }
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changeOrder(_vm.atrbInfo.depth1)
                                }
                              },
                              model: {
                                value: _vm.atrbInfo.depth1,
                                callback: function($$v) {
                                  _vm.$set(_vm.atrbInfo, "depth1", $$v)
                                },
                                expression: "atrbInfo.depth1"
                              }
                            },
                            _vm._l(_vm.atrbInfo.depth1, function(item, index) {
                              return _c(
                                "tr",
                                {
                                  key: item.contSeq,
                                  class:
                                    item.postTypeCd == "202004"
                                      ? ".item addBtn"
                                      : ".item"
                                },
                                [
                                  _c(
                                    "td",
                                    {
                                      class:
                                        item.postTypeCd == "202004"
                                          ? "table-info"
                                          : "",
                                      style: {
                                        backgroundColor:
                                          _vm.checkedDepth1[index] == true
                                            ? "#c1d5f8"
                                            : ""
                                      },
                                      attrs: { scope: "row" },
                                      on: {
                                        click: function($event) {
                                          _vm.atrbInfo.targetContSeqDepth2 = null
                                          _vm.getDepth3(item.contSeq)
                                          _vm.SelectChangeColor("depth1", index)
                                          _vm.isShowDepth2 = false
                                          _vm.isShowfiles = false
                                          _vm.selectUnitIndex[0] = index
                                          _vm.selectedContSeq = item.contSeq
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.editContSeq != item.contSeq,
                                              expression:
                                                "editContSeq!=item.contSeq "
                                            }
                                          ],
                                          staticStyle: {
                                            width: "calc(100% - 100px)"
                                          }
                                        },
                                        [
                                          _c("em", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  item.postTypeCd == "202005",
                                                expression:
                                                  "item.postTypeCd == '202005'"
                                              }
                                            ],
                                            staticClass: "fa fa-caret-right"
                                          }),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.editContSeq !=
                                                    item.contSeq,
                                                  expression:
                                                    "editContSeq!=item.contSeq"
                                                }
                                              ]
                                            },
                                            [_vm._v(_vm._s(item.title))]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                item.postTypeCd == "202004" &&
                                                _vm.editContSeq != item.contSeq,
                                              expression:
                                                "item.postTypeCd == '202004' && editContSeq !=item.contSeq"
                                            }
                                          ],
                                          staticClass:
                                            "btn btn-xs btn-outline-info mr-2 additem",
                                          attrs: {
                                            variant: "outline-info mr-2"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.addUnit(
                                                item,
                                                item.orderNum,
                                                "depth1"
                                              )
                                              _vm.popupShowDepthSmall = true
                                            }
                                          }
                                        },
                                        [_vm._v("+ 단계등록")]
                                      ),
                                      _vm.isShowDepth1
                                        ? _c("em", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.editContSeq !=
                                                  item.contSeq,
                                                expression:
                                                  "editContSeq!=item.contSeq"
                                              }
                                            ],
                                            staticClass:
                                              "fa fa-edit fa-pull-right",
                                            on: {
                                              click: function($event) {
                                                return _vm.editAttr(
                                                  item.contSeq
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _c(
                                        "b-input-group",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.editContSeq == item.contSeq,
                                              expression:
                                                "editContSeq==item.contSeq"
                                            }
                                          ]
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: { type: "text" },
                                            model: {
                                              value: item.title,
                                              callback: function($$v) {
                                                _vm.$set(item, "title", $$v)
                                              },
                                              expression: "item.title"
                                            }
                                          }),
                                          _c(
                                            "b-input-group-append",
                                            [
                                              _c(
                                                "b-btn",
                                                {
                                                  staticClass:
                                                    "btn btn-xs mr-2",
                                                  attrs: { variant: "warning" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.deleteAttr(
                                                        _vm.data.row.contSeq,
                                                        item.contSeq,
                                                        item.orderNum,
                                                        _vm.atrbInfo,
                                                        "unit"
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Delete")]
                                              ),
                                              _c(
                                                "b-btn",
                                                {
                                                  staticClass:
                                                    "btn btn-xs mr-2",
                                                  attrs: { variant: "info" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.saveAttr(
                                                        item.title,
                                                        item.pcontSeq
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Save")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("p", [
                    _vm._v("차시\n            "),
                    _c("span", { staticClass: "float-right" }, [
                      _c(
                        "span",
                        { staticClass: "float-right" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn btn-xs btn-outline-info mr-2",
                              attrs: { variant: "outline-info mr-2" },
                              on: {
                                click: function($event) {
                                  _vm.checkedDepth1Alert()
                                    ? (_vm.popupShowDepth2 = true)
                                    : (_vm.popupShowDepth2 = false)
                                }
                              }
                            },
                            [_vm._v("+ 차시등록")]
                          ),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isShowDepth2,
                                  expression: "!isShowDepth2"
                                }
                              ],
                              staticClass: "btn btn-xs btn-outline-info mr-2",
                              attrs: { variant: "outline-info mr-2" },
                              on: {
                                click: function($event) {
                                  _vm.clickChangeData("depth2")
                                  _vm.isShowDepth2 = true
                                }
                              }
                            },
                            [_vm._v("편집")]
                          ),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowDepth2,
                                  expression: "isShowDepth2"
                                }
                              ],
                              staticClass: "btn btn-xs btn-outline-info mr-2",
                              attrs: { variant: "outline-info mr-2" },
                              on: {
                                click: function($event) {
                                  _vm.resetOrderNum("depth2")
                                  _vm.isShowDepth2 = false
                                  _vm.editContSeq = 0
                                }
                              }
                            },
                            [_vm._v("취소")]
                          ),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowDepth2,
                                  expression: "isShowDepth2"
                                }
                              ],
                              staticClass: "btn btn-xs btn-outline-info mr-2",
                              attrs: { variant: "outline-info mr-2" },
                              on: {
                                click: function($event) {
                                  _vm.saveChangeOrder("depth2")
                                  _vm.isShowDepth2 = false
                                }
                              }
                            },
                            [_vm._v("저장")]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _c(
                    "table",
                    { staticClass: "table table-striped table-hover" },
                    [
                      _c(
                        "tbody",
                        { staticClass: "div_scroll" },
                        [
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.atrbInfo.depth2.length == 0,
                                  expression: "atrbInfo.depth2.length==0"
                                }
                              ],
                              staticClass: "text-center"
                            },
                            [_c("td", [_vm._v("No matching records")])]
                          ),
                          _c(
                            "draggable",
                            {
                              attrs: {
                                move: _vm.shouldDragToPosition,
                                options: {
                                  group: "depth2",
                                  disabled: !_vm.isShowDepth2
                                }
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changeOrder(
                                    _vm.atrbInfo.depth2,
                                    "depth2"
                                  )
                                }
                              },
                              model: {
                                value: _vm.atrbInfo.depth2,
                                callback: function($$v) {
                                  _vm.$set(_vm.atrbInfo, "depth2", $$v)
                                },
                                expression: "atrbInfo.depth2"
                              }
                            },
                            _vm._l(_vm.atrbInfo.depth2, function(item, index) {
                              return _c(
                                "tr",
                                {
                                  key: item.orderNum,
                                  class:
                                    item.postTypeCd == "202006" ? "addBtn" : "",
                                  attrs: {
                                    id:
                                      item.postTypeCd +
                                      "_" +
                                      item.contSeq +
                                      "_" +
                                      item.pcontSeq
                                  }
                                },
                                [
                                  _c(
                                    "td",
                                    {
                                      class:
                                        item.postTypeCd == "202006"
                                          ? "table-primary"
                                          : "",
                                      style: {
                                        backgroundColor:
                                          _vm.checkedDepth2[index] == true
                                            ? "#c4c1f8"
                                            : ""
                                      },
                                      attrs: { scope: "row" },
                                      on: {
                                        click: function($event) {
                                          _vm.getAtrbFiles(item.contSeq)
                                          _vm.isShowfiles = false
                                          _vm.SelectChangeColor("depth2", index)
                                          _vm.selectUnitIndex[1] = index
                                          _vm.selectedContSeq = item.contSeq
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.editContSeq != item.contSeq,
                                              expression:
                                                "editContSeq!=item.contSeq "
                                            }
                                          ],
                                          staticStyle: {
                                            width: "calc(100% - 100px)"
                                          }
                                        },
                                        [
                                          _c("em", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  item.postTypeCd == "202007",
                                                expression:
                                                  "item.postTypeCd == '202007'"
                                              }
                                            ],
                                            staticClass: "fa fa-caret-right"
                                          }),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.editContSeq !=
                                                    item.contSeq,
                                                  expression:
                                                    "editContSeq!=item.contSeq "
                                                }
                                              ]
                                            },
                                            [_vm._v(_vm._s(item.title))]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                item.postTypeCd == "202006" &&
                                                _vm.editContSeq != item.contSeq,
                                              expression:
                                                "item.postTypeCd == '202006' && editContSeq !=item.contSeq"
                                            }
                                          ],
                                          staticClass:
                                            "btn btn-xs btn-outline-info mr-2 additem",
                                          attrs: {
                                            variant: "outline-info mr-2"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.addUnit(
                                                item,
                                                item.orderNum,
                                                "depth2"
                                              )
                                              _vm.popupShowDepthSmall = true
                                            }
                                          }
                                        },
                                        [_vm._v("+ 코너등록")]
                                      ),
                                      _vm.isShowDepth2 &&
                                      _vm.editContSeq != item.contSeq
                                        ? _c("em", {
                                            staticClass:
                                              "fa fa-edit fa-pull-right",
                                            on: {
                                              click: function($event) {
                                                return _vm.editAttr(
                                                  item.contSeq
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _c(
                                        "b-input-group",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.editContSeq == item.contSeq,
                                              expression:
                                                "editContSeq==item.contSeq"
                                            }
                                          ]
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: { type: "text" },
                                            model: {
                                              value: item.title,
                                              callback: function($$v) {
                                                _vm.$set(item, "title", $$v)
                                              },
                                              expression: "item.title"
                                            }
                                          }),
                                          _c(
                                            "b-input-group-append",
                                            [
                                              _c(
                                                "b-btn",
                                                {
                                                  staticClass:
                                                    "btn btn-xs mr-2",
                                                  attrs: { variant: "warning" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.deleteAttr(
                                                        _vm.data.row.contSeq,
                                                        item.contSeq,
                                                        item.orderNum,
                                                        _vm.atrbInfo,
                                                        "unit-seq"
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Delete")]
                                              ),
                                              _c(
                                                "b-btn",
                                                {
                                                  staticClass:
                                                    "btn btn-xs mr-2",
                                                  attrs: { variant: "info" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.saveAttr(
                                                        item.title,
                                                        item.pcontSeq
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Save")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("p", [
                    _vm._v("개체\n            "),
                    _c(
                      "span",
                      { staticClass: "float-right" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn btn-xs btn-outline-info mr-2",
                            attrs: { variant: "outline-info mr-2" },
                            on: {
                              click: function($event) {
                                _vm.checkedDepthFiles("3")
                                  ? (_vm.popupShowDepth3 = true)
                                  : (_vm.popupShowDepth3 = false)
                              }
                            }
                          },
                          [_vm._v("개체등록")]
                        ),
                        _c(
                          "b-button",
                          {
                            staticClass: "btn btn-xs btn-outline-info mr-2",
                            attrs: { variant: "outline-info mr-2" },
                            on: {
                              click: function($event) {
                                _vm.checkedDepthFiles("4")
                                  ? (_vm.popupShowDepth4 = true)
                                  : (_vm.popupShowDepth4 = false)
                              }
                            }
                          },
                          [_vm._v("개체연결")]
                        ),
                        _c(
                          "b-button",
                          {
                            staticClass: "btn btn-xs btn-outline-info mr-2",
                            attrs: { variant: "outline-info mr-2" },
                            on: {
                              click: function($event) {
                                _vm.checkedDepthFiles("6")
                                  ? (_vm.popupShowDepth6 = true)
                                  : (_vm.popupShowDepth6 = false)
                              }
                            }
                          },
                          [_vm._v("온라인콘텐츠연결")]
                        ),
                        _c(
                          "b-button",
                          {
                            staticClass: "btn btn-xs btn-outline-info mr-2",
                            attrs: { variant: "outline-info mr-2" },
                            on: {
                              click: function($event) {
                                _vm.checkedDepthFiles("5")
                                  ? (_vm.popupShowDepth5 = true)
                                  : (_vm.popupShowDepth5 = false)
                              }
                            }
                          },
                          [_vm._v("용도변경")]
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isShowfiles,
                                expression: "!isShowfiles"
                              }
                            ],
                            staticClass: "btn btn-xs btn-outline-info mr-2",
                            attrs: { variant: "outline-info mr-2" },
                            on: {
                              click: function($event) {
                                _vm.clickChangeData("file")
                                _vm.isShowfiles = true
                              }
                            }
                          },
                          [_vm._v("편집")]
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowfiles,
                                expression: "isShowfiles"
                              }
                            ],
                            staticClass: "btn btn-xs btn-outline-info mr-2",
                            attrs: { variant: "outline-info mr-2" },
                            on: {
                              click: function($event) {
                                _vm.resetOrderNum("file")
                                _vm.isShowfiles = false
                                _vm.editContSeq = 0
                              }
                            }
                          },
                          [_vm._v("취소")]
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowfiles,
                                expression: "isShowfiles"
                              }
                            ],
                            staticClass: "btn btn-xs btn-outline-info mr-2",
                            attrs: { variant: "outline-info mr-2" },
                            on: {
                              click: function($event) {
                                _vm.saveChangeOrder("file")
                                _vm.isShowfiles = false
                              }
                            }
                          },
                          [_vm._v("저장")]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "table",
                    { staticClass: "table table-striped table-hover" },
                    [
                      _c(
                        "tbody",
                        { staticClass: "div_scroll" },
                        [
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.atrbInfo.files.length == 0 ||
                                    _vm.atrbInfo.files.length == null,
                                  expression:
                                    "atrbInfo.files.length == 0 || atrbInfo.files.length == null  "
                                }
                              ],
                              staticClass: "text-center"
                            },
                            [_c("td", [_vm._v("No matching records")])]
                          ),
                          _c(
                            "draggable",
                            {
                              attrs: {
                                options: {
                                  group: "files",
                                  disabled: !_vm.isShowfiles
                                }
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changeOrder(
                                    _vm.atrbInfo.files,
                                    "depth3"
                                  )
                                }
                              },
                              model: {
                                value: _vm.atrbInfo.files,
                                callback: function($$v) {
                                  _vm.$set(_vm.atrbInfo, "files", $$v)
                                },
                                expression: "atrbInfo.files"
                              }
                            },
                            _vm._l(_vm.atrbInfo.files, function(item, index) {
                              return _c(
                                "tr",
                                { key: item.fileSeq },
                                [
                                  _c("b-btn", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.editContSeq != item.fileSeq &&
                                          item.fileTypeCd != "211006"
                                            ? true
                                            : false,
                                        expression:
                                          "editContSeq!=item.fileSeq && item.fileTypeCd != '211006' ? true : false"
                                      }
                                    ],
                                    staticClass: "btn btn-xs mr-2 btn-down",
                                    on: {
                                      click: function($event) {
                                        _vm.popupShowFile = false
                                        _vm.downloadAs(
                                          item.fileDivCd,
                                          item.url,
                                          item.orgFileNm
                                        )
                                      }
                                    }
                                  }),
                                  _vm.isShowfiles
                                    ? _c("em", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.editContSeq != item.fileSeq,
                                            expression:
                                              "editContSeq!=item.fileSeq "
                                          }
                                        ],
                                        staticClass:
                                          "fa fa-edit fa-pull-right mr-2",
                                        staticStyle: { "margin-top": "1.25em" },
                                        on: {
                                          click: function($event) {
                                            return _vm.editAttr(item.fileSeq)
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "file",
                                      attrs: { scope: "row" },
                                      on: {
                                        mousemove: function($event) {
                                          return _vm.findFile(item.fileSeq)
                                        },
                                        click: function($event) {
                                          return _vm.popupFile(
                                            _vm.atrbInfo.fileSeq,
                                            item.fileSeq,
                                            item.mappingSeq
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.editContSeq != item.fileSeq,
                                              expression:
                                                "editContSeq!=item.fileSeq"
                                            }
                                          ],
                                          attrs: {
                                            variant: "outline-info mr-2"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.dispFileNm))]
                                      ),
                                      _c(
                                        "b-input-group",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.editContSeq == item.fileSeq,
                                              expression:
                                                "editContSeq==item.fileSeq"
                                            }
                                          ],
                                          on: {
                                            click: function($event) {
                                              _vm.atrbInfo.fileSeq = 0
                                            }
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: { type: "text" },
                                            model: {
                                              value: item.dispFileNm,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "dispFileNm",
                                                  $$v
                                                )
                                              },
                                              expression: "item.dispFileNm"
                                            }
                                          }),
                                          _c(
                                            "b-input-group-append",
                                            [
                                              _c(
                                                "b-btn",
                                                {
                                                  staticClass:
                                                    "btn btn-xs mr-2",
                                                  attrs: { variant: "warning" },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.popupShowFile = false
                                                      _vm.deleteAttr(
                                                        item.fileSeq,
                                                        item.mappingSeq,
                                                        item.orderNum,
                                                        _vm.atrbInfo,
                                                        "file"
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Delete")]
                                              ),
                                              _c(
                                                "b-btn",
                                                {
                                                  staticClass:
                                                    "btn btn-xs mr-2",
                                                  attrs: { variant: "info" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.saveAttrFile(
                                                        item.dispFileNm,
                                                        item.pcontSeq,
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Save")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "file-kind-wrap" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.editContSeq !=
                                                    item.fileSeq,
                                                  expression:
                                                    "editContSeq!=item.fileSeq"
                                                }
                                              ],
                                              staticClass: "file_kind"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        item.purpTypeCd != null
                                                          ? true
                                                          : false,
                                                      expression:
                                                        "item.purpTypeCd != null ? true : false "
                                                    }
                                                  ],
                                                  style: {
                                                    color:
                                                      _vm.atrbInfo.contColor[
                                                        index
                                                      ]
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.atrbInfo.contKind[
                                                        index
                                                      ]
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        item.teacherUseYn == "Y"
                                                          ? true
                                                          : false,
                                                      expression:
                                                        "item.teacherUseYn == 'Y' ? true : false "
                                                    }
                                                  ],
                                                  style: {
                                                    color:
                                                      item.teacherUseYn == "Y"
                                                        ? "#FF0000"
                                                        : ""
                                                  }
                                                },
                                                [_vm._v("교사")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        item.tutorUseYn == "Y"
                                                          ? true
                                                          : false,
                                                      expression:
                                                        "item.tutorUseYn == 'Y' ? true : false "
                                                    }
                                                  ],
                                                  style: {
                                                    color:
                                                      item.tutorUseYn == "Y"
                                                        ? "#708090"
                                                        : ""
                                                  }
                                                },
                                                [_vm._v("강사")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        item.studentUseYn == "Y"
                                                          ? true
                                                          : false,
                                                      expression:
                                                        "item.studentUseYn == 'Y' ? true : false "
                                                    }
                                                  ],
                                                  style: {
                                                    color:
                                                      item.studentUseYn == "Y"
                                                        ? "#800000"
                                                        : ""
                                                  }
                                                },
                                                [_vm._v("학생")]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.editContSeq !=
                                                    item.fileSeq,
                                                  expression:
                                                    "editContSeq!=item.fileSeq"
                                                }
                                              ],
                                              staticClass: "file_kind"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        item.fileTypeCd ==
                                                        "211006"
                                                          ? true
                                                          : false,
                                                      expression:
                                                        "item.fileTypeCd == '211006' ? true : false"
                                                    }
                                                  ]
                                                },
                                                [_vm._v("(온라인 콘텐츠)")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        item.fileTypeCd ==
                                                        "211005"
                                                          ? true
                                                          : false,
                                                      expression:
                                                        "item.fileTypeCd == '211005' ? true : false"
                                                    }
                                                  ]
                                                },
                                                [_vm._v("(웹콘텐츠)")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        item.fileTypeCd ==
                                                        "211004"
                                                          ? true
                                                          : false,
                                                      expression:
                                                        "item.fileTypeCd == '211004' ? true : false"
                                                    }
                                                  ]
                                                },
                                                [_vm._v("(웹콘텐츠링크)")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        item.ext != null
                                                          ? true
                                                          : false,
                                                      expression:
                                                        "item.ext != null  ? true : false"
                                                    }
                                                  ]
                                                },
                                                [
                                                  _vm._v(
                                                    "(" + _vm._s(item.ext) + ")"
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        item.playEndTime != "0"
                                                          ? true
                                                          : false,
                                                      expression:
                                                        "item.playEndTime != '0' ? true : false "
                                                    }
                                                  ]
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        item.playStartTime
                                                      ) +
                                                      " ~ " +
                                                      _vm._s(item.playEndTime) +
                                                      ")"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _c(
        "b-modal",
        { attrs: { id: "bookModal", size: "xl", title: "북샘 참고서 리스트" } },
        [
          _c("YcloudReferenceBookMstPage", {
            attrs: { bookId: _vm.data.row.bookId },
            on: { saveYcloudReferenceBook: _vm.saveYcloudReferenceBook }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "addBookModal",
            size: "xl",
            title: "참고서 등록",
            "hide-footer": ""
          },
          model: {
            value: _vm.popupShowDepthAddBook,
            callback: function($$v) {
              _vm.popupShowDepthAddBook = $$v
            },
            expression: "popupShowDepthAddBook"
          }
        },
        [
          _c("CsTextBookAddPage", {
            attrs: { bookTypeCd: 330002 },
            on: { search: _vm.search, "modal-state": _vm.popupClose }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "fileModal", size: "xl", title: "개체정보" },
          model: {
            value: _vm.popupShowFile,
            callback: function($$v) {
              _vm.popupShowFile = $$v
            },
            expression: "popupShowFile"
          }
        },
        [
          _c("CsFilePageInfo", {
            attrs: {
              fileSeq: _vm.atrbInfo.fileSeq,
              mappingSeq: _vm.atrbInfo.mappingSeq,
              contSeq:
                _vm.atrbInfo.targetContSeqDepth2 == null
                  ? _vm.atrbInfo.targetContSeqDepth1
                  : _vm.atrbInfo.targetContSeqDepth2,
              orgContSeq: _vm.data.row.contSeq,
              isShow: _vm.isShow,
              atrbInfo: _vm.atrbInfo,
              saveType: "txt",
              parentType: "txt"
            },
            on: { "modal-state": _vm.popupClose, "get-data": _vm.GetDepthData }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "fileRegModal",
            size: "xl",
            title: "개체등록",
            "hide-footer": ""
          },
          model: {
            value: _vm.popupShowDepth3,
            callback: function($$v) {
              _vm.popupShowDepth3 = $$v
            },
            expression: "popupShowDepth3"
          }
        },
        [
          _c("CsFileUploadPage", {
            attrs: {
              contSeq:
                _vm.atrbInfo.targetContSeqDepth2 == null
                  ? _vm.atrbInfo.targetContSeqDepth1
                  : _vm.atrbInfo.targetContSeqDepth2,
              orgContSeq: _vm.data.row.contSeq,
              isShow: _vm.isShow,
              selectedContSeq: _vm.selectedContSeq,
              atrbInfo: _vm.atrbInfo,
              saveType: "txt"
            },
            on: { "get-data": _vm.refreshFiles, "modal-state": _vm.popupClose }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "usingModalFiles",
            size: "xl",
            title: "개체용도변경",
            "hide-footer": ""
          },
          model: {
            value: _vm.popupShowDepth5,
            callback: function($$v) {
              _vm.popupShowDepth5 = $$v
            },
            expression: "popupShowDepth5"
          }
        },
        [
          _c("CsFileUsingPage", {
            attrs: {
              filedata: _vm.atrbInfo.files,
              postTypeCd: _vm.atrbInfo.targetPostTypeCd,
              atrbInfo: _vm.atrbInfo,
              index: _vm.selectUnitIndex,
              title: _vm.data.row.textbookNm,
              pContSeq1: _vm.atrbInfo.targetContSeqDepth1,
              pContSeq2: _vm.atrbInfo.targetContSeqDepth2,
              orgContSeq: _vm.data.row.contSeq,
              isShow: _vm.isShow
            },
            on: {
              "refresh-files": _vm.GetDepthData,
              "modal-state": _vm.popupClose
            }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "unitModalDepth",
            size: "ll",
            title: "하위등록",
            "hide-footer": ""
          },
          model: {
            value: _vm.popupShowDepthSmall,
            callback: function($$v) {
              _vm.popupShowDepthSmall = $$v
            },
            expression: "popupShowDepthSmall"
          }
        },
        [
          _c("CsUnitPage", {
            attrs: {
              fileSeq: _vm.atrbInfo.fileSeq,
              param: _vm.saveUnitInfo,
              atrbInfo: _vm.atrbInfo
            },
            on: { "modal-state": _vm.popupClose, "title-push": _vm.PushItem }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "uploadModalDepth1",
            size: "ll",
            title: "단원등록",
            "hide-footer": ""
          },
          model: {
            value: _vm.popupShowDepth1,
            callback: function($$v) {
              _vm.popupShowDepth1 = $$v
            },
            expression: "popupShowDepth1"
          }
        },
        [
          _c("CsUploadpage", {
            attrs: {
              fileSeq: _vm.atrbInfo.fileSeq,
              orderNum: _vm.atrbInfo.depth1.length,
              version: _vm.unit,
              atrbInfo: _vm.atrbInfo,
              pContSeq: _vm.data.row.contSeq,
              orgContSeq: _vm.data.row.contSeq
            },
            on: { "title-push": _vm.PushItem, "modal-state": _vm.popupClose }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "uploadModalDepth2",
            size: "ll",
            title: "차시단계등록",
            "hide-footer": ""
          },
          model: {
            value: _vm.popupShowDepth2,
            callback: function($$v) {
              _vm.popupShowDepth2 = $$v
            },
            expression: "popupShowDepth2"
          }
        },
        [
          _c("CsUploadpage", {
            attrs: {
              fileSeq: _vm.atrbInfo.fileSeq,
              orderNum: _vm.atrbInfo.depth2.length,
              version: _vm.unit_seq,
              atrbInfo: _vm.atrbInfo,
              pContSeq: _vm.atrbInfo.targetContSeqDepth1,
              orgContSeq: _vm.data.row.contSeq
            },
            on: { "title-push": _vm.PushItem, "modal-state": _vm.popupClose }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "uploadModalFiles", size: "xl", title: "개체연결" },
          model: {
            value: _vm.popupShowDepth4,
            callback: function($$v) {
              _vm.popupShowDepth4 = $$v
            },
            expression: "popupShowDepth4"
          }
        },
        [
          _c("CsTextBookFiles", {
            attrs: {
              extFileId: _vm.data.row.extFileId,
              atrbInfo: _vm.atrbInfo,
              pContSeq1: _vm.atrbInfo.targetContSeqDepth1,
              pContSeq2: _vm.atrbInfo.targetContSeqDepth2,
              orgContSeq: _vm.data.row.contSeq
            },
            on: { "get-data": _vm.getDepthData, "modal-state": _vm.popupClose }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "uploadModalFiles",
            size: "xl",
            title: "온라인콘텐츠연결"
          },
          model: {
            value: _vm.popupShowDepth6,
            callback: function($$v) {
              _vm.popupShowDepth6 = $$v
            },
            expression: "popupShowDepth6"
          }
        },
        [
          _c("CsTextBookFilesOnline", {
            attrs: {
              extFileId: _vm.data.row.extFileId,
              atrbInfo: _vm.atrbInfo,
              pContSeq1: _vm.atrbInfo.targetContSeqDepth1,
              pContSeq2: _vm.atrbInfo.targetContSeqDepth2,
              orgContSeq: _vm.data.row.contSeq
            },
            on: { "get-data": _vm.getDepthData, "modal-state": _vm.popupClose }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c("loading", {
        attrs: { active: _vm.data.params.isLoading, "is-full-page": true }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }